import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { mapFileToDocumentWidgetFiles } from '../utils';
import Loader from '@components/loader/Loader';
import DocumentWidget from '@components/widgets/document-widget/DocumentWidget';
import EnhancedButton from '@components/button/EnhancedButton';
import { getFacDocumentsQuery } from '../queries';
import { IFileCardProps } from '@models/file';
import AddFacDocumentDrawer from './AddFacDocumentDrawer';
import { CDN_URL } from '@utils';

const FacultativeDocumentsWidget = () => {
  const { id: currentFacId } = useParams<{ id: string }>();
  const [showAddDrawer, setShowAddDrawer] = useState<boolean>(false);

  const [documentsData, setDocumentsData] = useState<IFileCardProps[]>();

  const { refetch, data, loading } = useQuery(getFacDocumentsQuery, {
    variables: { FacultativeID: currentFacId },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    const docsList = mapFileToDocumentWidgetFiles(
      data?.Production?.queries?.GetFacDocuments
    );

    setDocumentsData(docsList);
  }, [data]);
  return loading ? (
    <Loader />
  ) : (
    <>
      <DocumentWidget
        title="Supporting Documents"
        cdnUrl={CDN_URL}
        files={documentsData}
        actions={
          <EnhancedButton
            isPrimary={false}
            onClick={() => setShowAddDrawer(true)}
          >
            Add Document
          </EnhancedButton>
        }
      />

      {showAddDrawer && (
        <AddFacDocumentDrawer
          currentFacId={currentFacId}
          isOpen={showAddDrawer}
          onClose={() => setShowAddDrawer(false)}
          onSuccess={() => refetch()}
        />
      )}
    </>
  );
};

export default FacultativeDocumentsWidget;
